import { GetDashboardDataConst } from "../constant/DashboardConstant";
import { GetDashboardDataService } from "../service/DashboardService";

export const GetDashboardDataAction = () => async (dispatch) => {
    try {
        const data = await GetDashboardDataService();
        dispatch({ type: GetDashboardDataConst, payload: data });
    } catch (error) {
        dispatch({ type: GetDashboardDataConst, payload: error });
        console.error("Dashboard data fetch error:", error);
    }
};
